import { Div, Button } from "@tblabs/truffle";
import { Step } from "../Steps/Step/Step";


export class StepActionsBox extends Div
{
    constructor(step: Step<any>, afterExecute: () => void)
    {
        super();
        this.MarginBottom(12)

        const actions = step.GetActions();

        if (actions)
        {
            this.Append(
                ...Object.entries(actions)
                    .map(([label, action]) =>
                        new Button(label, async () =>
                        {
                            await action();

                            afterExecute();
                        }).Class("uk-button uk-button-default").MarginLeft(4)
                    )
            );
        }
    }
}
